// import React from 'react';

// const BusRatesTable = () => {
//   const ratesData = [
    
//     { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "AURA", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "14", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "15", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA", mumbai: "6+1", mahabaleshwar: "18", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "SCORPIO", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA CRYSTA", mumbai: "6+1", mahabaleshwar: "20", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "AUDI", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "BUS", mumbai: "32-52", mahabaleshwar: "ON CALL", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "TAVERA", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//     { seater: "KIA Carens", mumbai: "6+1/7+1", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919970007784 ", driver: "Extra", parking: "Extra" },
//   ];

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     margin: "20px auto",
//   };

//   const thStyle = {
//     backgroundColor: "#5C0C2E",
//     color: "white",
//     padding: "8px",
//     border: "1px solid #ddd",
//   };

//   const tdStyle = {
//     padding: "8px",
//     border: "1px solid #ddd",
//     textAlign: "center",
//   };

//   const trEvenStyle = {
//     backgroundColor: "#f2f2f2",
//   };

//   const handleWhatsAppClick = (number, seater) => {
//     console.log(`Opening WhatsApp for ${seater} with number ${number}`);
//     const message = `Hi, I would like to inquire about the rates for the ${seater}.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="container p-0">
//       {/* <h3>Rates for AC Buses</h3> */}
//       <div className="table-responsive">
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Bus Name</th>
//               <th style={thStyle}>Seater</th>
//               <th style={thStyle}>Per KM</th>
//               <th style={thStyle}>Driver Food</th>
//               <th style={thStyle}>Toll Parking</th>
//               <th style={thStyle}>Book Now</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
//                 <td style={tdStyle}>{row.seater}</td>
//                 <td style={tdStyle}>{row.mumbai}</td>
//                 <td style={tdStyle}>{row.mahabaleshwar}</td>
//                 <td style={tdStyle}>{row.driver}</td>
//                 <td style={tdStyle}>{row.parking}</td>
//                 <td style={tdStyle}>
//                   <button
//                     onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#5C0C2E",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       color: "white",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//     </div>
//   );
// };

// export default BusRatesTable;


// import React from "react";

// const CabRatesTable = () => {
//   const ratesData = [
//     {
//       vehicle: "Dzire (Sedan)",
//       capacity: "4+1",
//       oneWay: "₹2700",
//       roundTrip: "₹5000",
//       toll: "Including",
//     },
//     {
//       vehicle: "Ertiga (6+1)",
//       capacity: "6+1",
//       oneWay: "₹3500",
//       roundTrip: "₹6500",
//       toll: "Including",
//     },
//     {
//       vehicle: "Kia Carens (6+1)",
//       capacity: "6+1",
//       oneWay: "₹4000",
//       roundTrip: "₹7000",
//       toll: "Including",
//     },
//     {
//       vehicle: "Innova Crysta (7+1)",
//       capacity: "7+1",
//       oneWay: "₹5000",
//       roundTrip: "₹9000",
//       toll: "Including",
//     },
//     {
//       vehicle: "Tempo Traveller (13 Seater)",
//       capacity: "13 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//     {
//       vehicle: "Tempo Traveller (17 Seater)",
//       capacity: "17 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//     {
//       vehicle: "Mini Bus (21 Seater)",
//       capacity: "21 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//     {
//       vehicle: "Mini Bus (32 Seater)",
//       capacity: "32 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//     {
//       vehicle: "Mini Bus (35 Seater)",
//       capacity: "35 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//     {
//       vehicle: "Mini Bus (50 Seater)",
//       capacity: "50 Seater",
//       oneWay: "On Call",
//       roundTrip: "On Call",
//       toll: "Including",
//     },
//   ];

//   const handleWhatsAppClick = (vehicle) => {
//     const number = "919970007784";

//     const message = `Hi Garud Cabs Services,

// I would like to book the ${vehicle}.

// Please share the complete details.

// Thank You.`;

//     window.open(
//       `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   return (
   

//     <div className="container my-4">
//   <div className="cab-rates-wrapper">
//     <div className="cab-rates-title">
//       <h2>Cab Rates</h2>
//       <p>Choose your vehicle and book your journey</p>
//     </div>

//     <div className="table-responsive">
//       <table className="table cab-rates-table">
//         <thead>
//           <tr>
//             <th>TYPE OF VEHICLE</th>
//             <th>CAPACITY</th>
//             <th>ONE WAY PRICE</th>
//             <th>ROUND TRIP (RETURN)</th>
//             <th>TOLL & PARKING</th>
//             <th>BOOK NOW</th>
//           </tr>
//         </thead>

//         <tbody>
//           {ratesData.map((item, index) => (
//             <tr key={index}>
//               <td className="vehicle-name">{item.vehicle}</td>
//               <td>{item.capacity}</td>
//               <td className="price">{item.oneWay}</td>
//               <td className="price">{item.roundTrip}</td>
//               <td>
//                 <span className="toll-badge">{item.toll}</span>
//               </td>
//               <td>
//                 <button
//                   className="book-btn"
//                   onClick={() => handleWhatsAppClick(item.vehicle)}
//                 >
//                   Book Now
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// </div>

//   );
// };

// export default CabRatesTable;







import React from "react";

const CabRatesTable = () => {
  const ratesData = [
    {
      vehicle: "Dzire",
      capacity: "4+1",
      rate: "₹12/km",
    },
    {
      vehicle: "Ertiga / Rumion",
      capacity: "6+1",
      rate: "₹15/km",
    },
    {
      vehicle: "Kia Carens",
      capacity: "6+1",
      rate: "₹18/km",
    },
    {
      vehicle: "Innova Crysta",
      capacity: "7+1",
      rate: "₹20/km",
    },
    {
      vehicle: "Innova Hycross",
      capacity: "7+1",
      rate: "₹26/km",
    },
    {
      vehicle: "Winger",
      capacity: "9+1 Seater",
      rate: "₹25/km",
    },
    {
      vehicle: "Winger",
      capacity: "12 Seater",
      rate: "₹26/km",
    },
    {
      vehicle: "Tempo Traveller",
      capacity: "17 Seater",
      rate: "₹28/km",
    },
    {
      vehicle: "Tempo Traveller",
      capacity: "20 Seater",
      rate: "₹32/km",
    },
    {
      vehicle: "Urbania",
      capacity: "—",
      rate: "₹38/km",
    },
  ];

  const handleWhatsAppClick = (vehicle, capacity) => {
    const number = "919970007784";

    const message = `Hi Garud Cabs Services,

I would like to book the ${vehicle} (${capacity}).

Please share the complete booking details and availability.

Thank You.`;

    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div className="container my-4">
      <div className="cab-rates-wrapper">
        <div className="cab-rates-title">
          <h2>Cab & Travel Rates</h2>
          <p>Choose your vehicle and book your journey</p>
        </div>

        {/* Important Terms */}
        <div className="cab-rate-info">
          <div className="info-item">
            <strong>🚗 All Vehicles</strong>
            <span>AC Cab & Travels</span>
          </div>

          <div className="info-item">
            <strong>📍 Minimum Running</strong>
            <span>300 KM per day</span>
          </div>

          <div className="info-item">
            <strong>💰 Extra Charges</strong>
            <span>Toll, Parking & Driver Food Extra</span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table cab-rates-table">
            <thead>
              <tr>
                <th>TYPE OF VEHICLE</th>
                <th>CAPACITY</th>
                <th>RATE</th>
                <th>MIN. KM / DAY</th>
                <th>EXTRA CHARGES</th>
                <th>BOOK NOW</th>
              </tr>
            </thead>

            <tbody>
              {ratesData.map((item, index) => (
                <tr key={index}>
                  <td className="vehicle-name">{item.vehicle}</td>

                  <td>{item.capacity}</td>

                  <td className="price">{item.rate}</td>

                  <td>
                    <span className="km-badge">300 KM</span>
                  </td>

                  <td>
                    <span className="extra-badge">
                      Toll + Parking + Driver Food
                    </span>
                  </td>

                  <td>
                    <button
                      className="book-btn"
                      onClick={() =>
                        handleWhatsAppClick(item.vehicle, item.capacity)
                      }
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bottom Note */}
        <div className="cab-rate-note">
          <strong>Note:</strong> All rates are per kilometer. Minimum
          <strong> 300 KM running per day</strong>. Toll, parking and driver
          food charges are <strong>extra</strong>.
        </div>
      </div>
    </div>
  );
};

export default CabRatesTable;
